import { Tooltip } from "@mui/material";
import { tv } from "tailwind-variants";

/**
 * Style
 */

const { bg, text } = tv({
  slots: {
    bg: "flex items-center justify-center border-grey-500/30 rounded-[4px] cursor-pointer",
    text: "font-semibold",
  },
  variants: {
    size: {
      "default": { bg: "w-7 h-7" },
      "autowidth": { bg: "w-auto h-7 px-2" }
    },
    textSize: {
      "default": {
        text: "text-base",
      },
      "small": {
        text: "text-xs",
      },
      "extraSmall": {
        text: "text-[0.65rem]",
      }
    },
    color: {
      red: {
        bg: "bg-red-500",
        text: "text-white"
      },
      blue: {
        bg: "bg-blue-500",
        text: "text-white"
      },
      yellow: {
        bg: "bg-yellow-400",
        text: "text-white"
      },
      green: {
        bg: "bg-primary-green",
        text: "text-white"
      },
      gray: {
        bg: "bg-gray-400/30",
        text: "text-white"
      },
      "light-blue": {
        bg: "bg-[#89c4f4]",
        text: "text-white"
      },
      orange: {
        bg: "bg-orange-400",
        text: "text-white"
      },
      darkorange: {
        bg: "bg-orange-700",
        text: "text-white"
      }
    }
  }
})()

/**
 * ItemStatus
 */

interface Props {
  color: "red" | "blue" | "yellow" | "green" | "gray" | "light-blue" | "orange" | "darkorange";
  title: string;
  description: string;
  width?: string;
  size?: "default" | "autowidth";
  textSize?: "default" | "small" | "extraSmall";
}

function ItemStatus({ color, title, description, width, size = "default", textSize = "default" }: Props) {
  return (
    <>
      <Tooltip title={description}>
        <div className={bg({ color: color, size: size })} style={{ width }}>
          <h1
            style={{ textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000' }}
            className={text({ color: color, textSize: textSize })}>
            {title}
          </h1>
        </div>
      </Tooltip >
    </>
  );
}

export default ItemStatus;